import { useTenant } from '@/shared/contexts/TenantContext'

/** Event slug from host (white-label); required on tenant routes. */
export function useEventSlug(): string {
  const { eventSlug, hasTenant } = useTenant()

  if (!hasTenant || !eventSlug) {
    throw new Error(
      'No tenant on this host — use a mapped domain (see DOMAIN_MAP) or event subdomain'
    )
  }

  return eventSlug
}
